<script>
  import GuestCell from "../component/GuestCell.svelte";

  export let guests;
  export let wedding_guid;
  export let search;
</script>

{#each $guests as g, i (g[0].invitation_id)}
  <GuestCell
    {wedding_guid}
    {search}
    invitation_id={g[0].invitation_id}
    group={g}
    bind:isOpened={g[0].isOpened}
    on:refresh
    on:refresh_count />
{/each}
